
export const baseUrl = "https://d3nygaq1s5m8el.cloudfront.net/";//"https://tes-minat-bakat-images.s3-ap-southeast-1.amazonaws.com/";
export const logo = `${baseUrl}new-logo-w-tmb.png`